// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkflowsTable_container__I8EY5 {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*background-color: rgba(240, 243, 247, 0.2);*/
    /*border: 1px solid #707070;*/
    /*border-radius: 8px;*/
    /*overflow: hidden;*/
    padding: 20px 0;
    /*max-height: calc(100vh - var(--header-height) - 260px);*/
    /*min-height: calc(100vh - var(--header-height) - 260px);*/
}

.WorkflowsTable_header__eSGmV {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
    padding: 0 20px;
}

.WorkflowsTable_title__CD6gT {
    margin: 0;
    display: flex;
    align-items: center;
    grid-gap: 17px;
}

.WorkflowsTable_title__CD6gT img {
    width: 24px;
}

.WorkflowsTable_searchBar__2mDgB {
    display: flex;
    gap: 12px;
    align-items: center;
}

.WorkflowsTable_searchInputWrapper__NuRrf {
    position: relative;
    flex: 1 1;
    display: flex;
    align-items: center;
}

.WorkflowsTable_searchIcon__h90bm {
    position: absolute;
    left: 12px;
    z-index: 1;
    color: #7b848e;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    width: 16px;
    height: 16px;
}

.WorkflowsTable_searchIcon__h90bm svg {
    width: 16px;
    height: 16px;
    max-width: 16px;
    max-height: 16px;
}

.WorkflowsTable_searchInput__HHZfO {
    width: 100%;
    padding: 10px 12px 10px 40px;
    border: 1px solid var(--light-grey);
    border-radius: 4px;
    font-size: 14px;
    outline: none;
}

.WorkflowsTable_searchInput__HHZfO:focus {
    border-color: var(--primary-color, #007bff);
}

.WorkflowsTable_filterButton__ExcvL {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    border: 1px solid var(--light-grey);
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: background-color 0.2s;
}

.WorkflowsTable_filterButton__ExcvL:hover {
    background-color: #f5f5f5;
}

.WorkflowsTable_listContainerOuter__Sy3ak {
    /*overflow-y: auto;*/
    padding: 0 20px;
    /*border: 0.5px dashed var(--dark-grey);*/
    position: relative;
}

/*.listContainerOuter:before {*/
/*    content: '';*/
/*    border: 0.5px dashed var(--dark-grey);*/
/*    border-radius: 3px;*/
/*    position: absolute;*/
/*    z-index: 0;*/
/*    width: calc(100% - 40px);*/
/*    left: 20px;*/
/*    top: 0;*/
/*    height: 100%;*/
/*}*/

.WorkflowsTable_listContainer__j49k9 {
    position: relative;
    border: 0.5px dashed var(--dark-grey);
    border-radius: 3px;
    /*z-index: 1;*/
    /*padding: 8px;*/
    /*background: var(--white-active);*/
    background: #fff;
    flex: 1 1;
}

.WorkflowsTable_treeNode__R1m5G {
    display: flex;
    flex-direction: column;
}

.WorkflowsTable_nodeRow__HpepB {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    min-height: 32px;
}

.WorkflowsTable_nodeRow__HpepB button {
    font-size: inherit;
    /*align-items: center;*/
    /*grid-gap: 8px;*/
    width: 100%;
    display: grid;
    grid-template-columns: 38px 38px 1fr;
    /*padding: 14px 8px;*/
    padding: 1px 0;

    text-align: left;
    justify-content: start;
}

.WorkflowsTable_nodeRowHeaderIcon__3zJ04 {
    --icon-color-outer-custom: var(--primary-color-active);
    color: var(--dark-grey);
    display: flex;
    align-items: center;
    justify-content: center;
}

.WorkflowsTable_nodeRowHeaderIcon__3zJ04 > span {
    width: 20px;
    height: 20px;
}

.WorkflowsTable_expandButton__U9Wip {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    background: white;
    border: 1px solid var(--primary-color-active, #007bff);
    border-radius: 3px;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
}

.WorkflowsTable_expandPlaceholder__yBcTa {
    /*width: 25px;*/
    /*height: 25px;*/
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding-left: 8px;
}

.WorkflowsTable_expandSubPlaceholder__fOwO\\+ {
    font-weight: 300;
    color: #000;
    margin-left: 25px;
}

.WorkflowsTable_columnType__us5Bb {
    margin-right: 4px;
    /*font-size: 20px;*/
    color: var(--dark-grey);
}

.WorkflowsTable_chevron__HwhY1 {
    transition: transform 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(270deg);
}

.WorkflowsTable_chevron__HwhY1 svg {
    width: 12px;
    height: 12px;
}

.WorkflowsTable_chevron__HwhY1.WorkflowsTable_expanded__kRgf2 {
    transform: rotate(0deg);
    color: var(--primary-color-active, #007bff);
}

.WorkflowsTable_checkboxWrapper__Xawyl {
    --checkbox-bg-color: var(--primary-color-active, #007bff);
    display: flex;
    align-items: center;
}

.WorkflowsTable_checkboxWrapper__Xawyl .checkbox {
    background: white;
    border-color: var(--primary-color-active, #007bff);
}

.WorkflowsTable_checkboxWrapper__Xawyl .checkbox.checked {
    background: var(--primary-color-active, #007bff);
    border-color: var(--primary-color-active, #007bff);
}

.WorkflowsTable_checkboxWrapper__Xawyl label {
    display: flex;
    align-items: center;
    margin: 0;
}

.WorkflowsTable_actions__QRG25 {
    background: var(--dark-grey);
    border-radius: 5px;
    padding: 4px;
    display: flex;
    grid-gap: 3px;
    margin-right: 11px;
}

.WorkflowsTable_action__T8Cvn {
    cursor: pointer;
}
.WorkflowsTable_action__T8Cvn input {
    display: none;
}
.WorkflowsTable_action__T8Cvn span {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--dark-grey);
    padding: 1px 6px;
    border-radius: 2px;
    color: #fff;
    font-size: 16px;
    height: 25px;
    transition: background-color 0.4s;
}

.WorkflowsTable_action__T8Cvn input:checked + span {
    background: var(--primary-color-active);
}

.WorkflowsTable_actionBtn__je3GB {
    --icon-color-custom: #0c3b8d;
    background: var(--primary-color);
    border-radius: 5px;
    padding: 0 4px;
    width: 40px;
    height: 32px;
    transition: background-color 0.4s;
}

.WorkflowsTable_actionBtn__je3GB:hover {
    background: var(--primary-color-active);
}

.WorkflowsTable_actionBtn__je3GB:disabled {
    background: var(--dark-grey);
    --icon-color-custom: var(--dark-grey);
}

.WorkflowsTable_footer__QbOYA {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    margin-top: 30px;
    /*border-top: 1px solid #e0e0e0;*/
}

.WorkflowsTable_selectedCount__wAAv2 {
    font-size: 14px;
    color: #666;
    font-weight: 500;
}

.WorkflowsTable_runTaskButton__HKKCs {
    padding: 10px 24px;
    background-color: var(--primary-color, #007bff);
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
}

.WorkflowsTable_runTaskButton__HKKCs:hover {
    background-color: var(--primary-color-active, #0056b3);
}

.WorkflowsTable_emptyState__Elo-H {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 16px;
}

.WorkflowsTable_table__rtPFb {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.WorkflowsTable_table__rtPFb th {
    background: #fff;
    border: 0.5px solid var(--dark-grey);
    padding: 10px;
    text-align: left;
    font-weight: 500;
}

.WorkflowsTable_table__rtPFb th:not(:first-child) {
    border-left-style: dashed;
}

.WorkflowsTable_table__rtPFb th:not(:last-child) {
    border-right-style: dashed;
}

.WorkflowsTable_table__rtPFb td {
    background: #fff;
    border: 0.5px solid var(--dark-grey);
    border-left-style: dashed;
    border-right-style: dashed;
    border-top: 0;

    padding: 5px;
}

.WorkflowsTable_table__rtPFb td:first-child,
.WorkflowsTable_table__rtPFb td:nth-child(2) {
    text-align: center;
    padding: 10px;
}

.WorkflowsTable_truncatedInputWrap__FjoTU {
    position: relative;
    display: block;
    width: 100%;
    min-width: 0;
}

.WorkflowsTable_truncatedInputTooltip__QJF60 {
    position: absolute;
    left: -4px;
    bottom: -2px;
    /*margin-bottom: 0px;*/
    padding: 5px 10px;
    width: calc(100% + 20px);
    background: var(--primary-color-light);
    border: 0.5px dashed var(--dark-grey);
    color: #000;
    /*font-size: 16px;*/
    /*line-height: 1.4;*/
    white-space: normal;
    word-break: break-word;
    border-radius: 2px;
    z-index: 14;
    pointer-events: none;
}

.WorkflowsTable_table__rtPFb td input[type='text'] {
    font-size: inherit;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 0;
    padding: 5px;
    border-bottom: 0.5px dashed transparent;
    transition: border-color 0.4s;
    box-sizing: border-box;
}

.WorkflowsTable_table__rtPFb tr:focus-within td input[type='text'] {
    border-bottom-color: var(--dark-grey);
}

/*.table tr:first-child td {*/
/*    border-top: 0;*/
/*}*/

.WorkflowsTable_table__rtPFb tr:not(:last-child) td {
    border-bottom-style: dashed;
}

.WorkflowsTable_table__rtPFb td:not(:last-child) {
    border-right-style: dashed;
}
.WorkflowsTable_table__rtPFb td:not(:first-child) {
    border-left: 0;
}

/*.table td {*/
/*    width: 50%;*/
/*}*/

.WorkflowsTable_table__rtPFb td:nth-child(n + 3) {
    width: auto;
}

.WorkflowsTable_table__rtPFb th:nth-child(1),
.WorkflowsTable_table__rtPFb th:nth-child(2),
.WorkflowsTable_table__rtPFb td:nth-child(1),
.WorkflowsTable_table__rtPFb td:nth-child(2) {
    width: 38px;
    min-width: 38px;
    max-width: 38px;

    overflow: hidden;
}

.WorkflowsTable_table__rtPFb th:nth-child(3),
.WorkflowsTable_table__rtPFb td:nth-child(3) {
    width: 30%;
    max-width: 30%;
}

.WorkflowsTable_tableVertical__8q95a td:nth-child(3) {
    color: var(--dark-grey);
    position: relative;
}

.WorkflowsTable_tableVertical__8q95a td .WorkflowsTable_columnType__us5Bb {
    margin-right: auto;
    position: absolute;
    right: 44px;
}

.WorkflowsTable_addBtn__6KEs7 {
    position: absolute;
    z-index: 2;
    right: -11px;
    bottom: -11px;
    border-radius: 50%;
    width: 21px;
    height: 21px;
    background: #fff;
    border: 1px solid var(--primary-color);
    --icon-color-custom: var(--primary-color);
    --icon-stroke: 1;
    padding: 3px;

    transition: background-color 0.4s;

    /* temp */
    /*display: none;*/
    /*pointer-events: none;*/
}

.WorkflowsTable_addBtn__6KEs7:hover {
    background: var(--primary-color);
    --icon-color-custom: #fff;
}

.WorkflowsTable_addBtn__6KEs7 * {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Workflows/components/WorkflowsTable.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8CAA8C;IAC9C,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,0DAA0D;IAC1D,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B,mBAAmB;AACnB,6CAA6C;AAC7C,0BAA0B;AAC1B,0BAA0B;AAC1B,kBAAkB;AAClB,gCAAgC;AAChC,kBAAkB;AAClB,cAAc;AACd,oBAAoB;AACpB,IAAI;;AAEJ;IACI,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,qBAAqB;IACrB,cAAc;;IAEd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sDAAsD;IACtD,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sDAAsD;IACtD,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,yDAAyD;IACzD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;IACI,gDAAgD;IAChD,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,0BAA0B;IAC1B,aAAa;;IAEb,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,sCAAsC;IACtC,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,uCAAuC;IACvC,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA,6BAA6B;AAC7B,qBAAqB;AACrB,IAAI;;AAEJ;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd,kBAAkB;AAClB,IAAI;;AAEJ;IACI,WAAW;AACf;;AAEA;;;;IAII,WAAW;IACX,eAAe;IACf,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,yCAAyC;IACzC,gBAAgB;IAChB,YAAY;;IAEZ,iCAAiC;;IAEjC,SAAS;IACT,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    /*background-color: rgba(240, 243, 247, 0.2);*/\n    /*border: 1px solid #707070;*/\n    /*border-radius: 8px;*/\n    /*overflow: hidden;*/\n    padding: 20px 0;\n    /*max-height: calc(100vh - var(--header-height) - 260px);*/\n    /*min-height: calc(100vh - var(--header-height) - 260px);*/\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 20px;\n    padding: 0 20px;\n}\n\n.title {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    grid-gap: 17px;\n}\n\n.title img {\n    width: 24px;\n}\n\n.searchBar {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.searchInputWrapper {\n    position: relative;\n    flex: 1;\n    display: flex;\n    align-items: center;\n}\n\n.searchIcon {\n    position: absolute;\n    left: 12px;\n    z-index: 1;\n    color: #7b848e;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    width: 16px;\n    height: 16px;\n}\n\n.searchIcon svg {\n    width: 16px;\n    height: 16px;\n    max-width: 16px;\n    max-height: 16px;\n}\n\n.searchInput {\n    width: 100%;\n    padding: 10px 12px 10px 40px;\n    border: 1px solid var(--light-grey);\n    border-radius: 4px;\n    font-size: 14px;\n    outline: none;\n}\n\n.searchInput:focus {\n    border-color: var(--primary-color, #007bff);\n}\n\n.filterButton {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 16px;\n    border: 1px solid var(--light-grey);\n    border-radius: 4px;\n    background: white;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.filterButton:hover {\n    background-color: #f5f5f5;\n}\n\n.listContainerOuter {\n    /*overflow-y: auto;*/\n    padding: 0 20px;\n    /*border: 0.5px dashed var(--dark-grey);*/\n    position: relative;\n}\n\n/*.listContainerOuter:before {*/\n/*    content: '';*/\n/*    border: 0.5px dashed var(--dark-grey);*/\n/*    border-radius: 3px;*/\n/*    position: absolute;*/\n/*    z-index: 0;*/\n/*    width: calc(100% - 40px);*/\n/*    left: 20px;*/\n/*    top: 0;*/\n/*    height: 100%;*/\n/*}*/\n\n.listContainer {\n    position: relative;\n    border: 0.5px dashed var(--dark-grey);\n    border-radius: 3px;\n    /*z-index: 1;*/\n    /*padding: 8px;*/\n    /*background: var(--white-active);*/\n    background: #fff;\n    flex: 1;\n}\n\n.treeNode {\n    display: flex;\n    flex-direction: column;\n}\n\n.nodeRow {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 0;\n    min-height: 32px;\n}\n\n.nodeRow button {\n    font-size: inherit;\n    /*align-items: center;*/\n    /*grid-gap: 8px;*/\n    width: 100%;\n    display: grid;\n    grid-template-columns: 38px 38px 1fr;\n    /*padding: 14px 8px;*/\n    padding: 1px 0;\n\n    text-align: left;\n    justify-content: start;\n}\n\n.nodeRowHeaderIcon {\n    --icon-color-outer-custom: var(--primary-color-active);\n    color: var(--dark-grey);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.nodeRowHeaderIcon > span {\n    width: 20px;\n    height: 20px;\n}\n\n.expandButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 25px;\n    height: 25px;\n    background: white;\n    border: 1px solid var(--primary-color-active, #007bff);\n    border-radius: 3px;\n    cursor: pointer;\n    padding: 0;\n    flex-shrink: 0;\n}\n\n.expandPlaceholder {\n    /*width: 25px;*/\n    /*height: 25px;*/\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    padding-left: 8px;\n}\n\n.expandSubPlaceholder {\n    font-weight: 300;\n    color: #000;\n    margin-left: 25px;\n}\n\n.columnType {\n    margin-right: 4px;\n    /*font-size: 20px;*/\n    color: var(--dark-grey);\n}\n\n.chevron {\n    transition: transform 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: rotate(270deg);\n}\n\n.chevron svg {\n    width: 12px;\n    height: 12px;\n}\n\n.chevron.expanded {\n    transform: rotate(0deg);\n    color: var(--primary-color-active, #007bff);\n}\n\n.checkboxWrapper {\n    --checkbox-bg-color: var(--primary-color-active, #007bff);\n    display: flex;\n    align-items: center;\n}\n\n.checkboxWrapper :global(.checkbox) {\n    background: white;\n    border-color: var(--primary-color-active, #007bff);\n}\n\n.checkboxWrapper :global(.checkbox.checked) {\n    background: var(--primary-color-active, #007bff);\n    border-color: var(--primary-color-active, #007bff);\n}\n\n.checkboxWrapper :global(label) {\n    display: flex;\n    align-items: center;\n    margin: 0;\n}\n\n.actions {\n    background: var(--dark-grey);\n    border-radius: 5px;\n    padding: 4px;\n    display: flex;\n    grid-gap: 3px;\n    margin-right: 11px;\n}\n\n.action {\n    cursor: pointer;\n}\n.action input {\n    display: none;\n}\n.action span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--dark-grey);\n    padding: 1px 6px;\n    border-radius: 2px;\n    color: #fff;\n    font-size: 16px;\n    height: 25px;\n    transition: background-color 0.4s;\n}\n\n.action input:checked + span {\n    background: var(--primary-color-active);\n}\n\n.actionBtn {\n    --icon-color-custom: #0c3b8d;\n    background: var(--primary-color);\n    border-radius: 5px;\n    padding: 0 4px;\n    width: 40px;\n    height: 32px;\n    transition: background-color 0.4s;\n}\n\n.actionBtn:hover {\n    background: var(--primary-color-active);\n}\n\n.actionBtn:disabled {\n    background: var(--dark-grey);\n    --icon-color-custom: var(--dark-grey);\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 0 20px;\n    margin-top: 30px;\n    /*border-top: 1px solid #e0e0e0;*/\n}\n\n.selectedCount {\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n}\n\n.runTaskButton {\n    padding: 10px 24px;\n    background-color: var(--primary-color, #007bff);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.runTaskButton:hover {\n    background-color: var(--primary-color-active, #0056b3);\n}\n\n.emptyState {\n    padding: 40px;\n    text-align: center;\n    color: #999;\n    font-size: 16px;\n}\n\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n}\n\n.table th {\n    background: #fff;\n    border: 0.5px solid var(--dark-grey);\n    padding: 10px;\n    text-align: left;\n    font-weight: 500;\n}\n\n.table th:not(:first-child) {\n    border-left-style: dashed;\n}\n\n.table th:not(:last-child) {\n    border-right-style: dashed;\n}\n\n.table td {\n    background: #fff;\n    border: 0.5px solid var(--dark-grey);\n    border-left-style: dashed;\n    border-right-style: dashed;\n    border-top: 0;\n\n    padding: 5px;\n}\n\n.table td:first-child,\n.table td:nth-child(2) {\n    text-align: center;\n    padding: 10px;\n}\n\n.truncatedInputWrap {\n    position: relative;\n    display: block;\n    width: 100%;\n    min-width: 0;\n}\n\n.truncatedInputTooltip {\n    position: absolute;\n    left: -4px;\n    bottom: -2px;\n    /*margin-bottom: 0px;*/\n    padding: 5px 10px;\n    width: calc(100% + 20px);\n    background: var(--primary-color-light);\n    border: 0.5px dashed var(--dark-grey);\n    color: #000;\n    /*font-size: 16px;*/\n    /*line-height: 1.4;*/\n    white-space: normal;\n    word-break: break-word;\n    border-radius: 2px;\n    z-index: 14;\n    pointer-events: none;\n}\n\n.table td input[type='text'] {\n    font-size: inherit;\n    width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    border: 0;\n    padding: 5px;\n    border-bottom: 0.5px dashed transparent;\n    transition: border-color 0.4s;\n    box-sizing: border-box;\n}\n\n.table tr:focus-within td input[type='text'] {\n    border-bottom-color: var(--dark-grey);\n}\n\n/*.table tr:first-child td {*/\n/*    border-top: 0;*/\n/*}*/\n\n.table tr:not(:last-child) td {\n    border-bottom-style: dashed;\n}\n\n.table td:not(:last-child) {\n    border-right-style: dashed;\n}\n.table td:not(:first-child) {\n    border-left: 0;\n}\n\n/*.table td {*/\n/*    width: 50%;*/\n/*}*/\n\n.table td:nth-child(n + 3) {\n    width: auto;\n}\n\n.table th:nth-child(1),\n.table th:nth-child(2),\n.table td:nth-child(1),\n.table td:nth-child(2) {\n    width: 38px;\n    min-width: 38px;\n    max-width: 38px;\n\n    overflow: hidden;\n}\n\n.table th:nth-child(3),\n.table td:nth-child(3) {\n    width: 30%;\n    max-width: 30%;\n}\n\n.tableVertical td:nth-child(3) {\n    color: var(--dark-grey);\n    position: relative;\n}\n\n.tableVertical td .columnType {\n    margin-right: auto;\n    position: absolute;\n    right: 44px;\n}\n\n.addBtn {\n    position: absolute;\n    z-index: 2;\n    right: -11px;\n    bottom: -11px;\n    border-radius: 50%;\n    width: 21px;\n    height: 21px;\n    background: #fff;\n    border: 1px solid var(--primary-color);\n    --icon-color-custom: var(--primary-color);\n    --icon-stroke: 1;\n    padding: 3px;\n\n    transition: background-color 0.4s;\n\n    /* temp */\n    /*display: none;*/\n    /*pointer-events: none;*/\n}\n\n.addBtn:hover {\n    background: var(--primary-color);\n    --icon-color-custom: #fff;\n}\n\n.addBtn * {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WorkflowsTable_container__I8EY5`,
	"header": `WorkflowsTable_header__eSGmV`,
	"title": `WorkflowsTable_title__CD6gT`,
	"searchBar": `WorkflowsTable_searchBar__2mDgB`,
	"searchInputWrapper": `WorkflowsTable_searchInputWrapper__NuRrf`,
	"searchIcon": `WorkflowsTable_searchIcon__h90bm`,
	"searchInput": `WorkflowsTable_searchInput__HHZfO`,
	"filterButton": `WorkflowsTable_filterButton__ExcvL`,
	"listContainerOuter": `WorkflowsTable_listContainerOuter__Sy3ak`,
	"listContainer": `WorkflowsTable_listContainer__j49k9`,
	"treeNode": `WorkflowsTable_treeNode__R1m5G`,
	"nodeRow": `WorkflowsTable_nodeRow__HpepB`,
	"nodeRowHeaderIcon": `WorkflowsTable_nodeRowHeaderIcon__3zJ04`,
	"expandButton": `WorkflowsTable_expandButton__U9Wip`,
	"expandPlaceholder": `WorkflowsTable_expandPlaceholder__yBcTa`,
	"expandSubPlaceholder": `WorkflowsTable_expandSubPlaceholder__fOwO+`,
	"columnType": `WorkflowsTable_columnType__us5Bb`,
	"chevron": `WorkflowsTable_chevron__HwhY1`,
	"expanded": `WorkflowsTable_expanded__kRgf2`,
	"checkboxWrapper": `WorkflowsTable_checkboxWrapper__Xawyl`,
	"actions": `WorkflowsTable_actions__QRG25`,
	"action": `WorkflowsTable_action__T8Cvn`,
	"actionBtn": `WorkflowsTable_actionBtn__je3GB`,
	"footer": `WorkflowsTable_footer__QbOYA`,
	"selectedCount": `WorkflowsTable_selectedCount__wAAv2`,
	"runTaskButton": `WorkflowsTable_runTaskButton__HKKCs`,
	"emptyState": `WorkflowsTable_emptyState__Elo-H`,
	"table": `WorkflowsTable_table__rtPFb`,
	"truncatedInputWrap": `WorkflowsTable_truncatedInputWrap__FjoTU`,
	"truncatedInputTooltip": `WorkflowsTable_truncatedInputTooltip__QJF60`,
	"tableVertical": `WorkflowsTable_tableVertical__8q95a`,
	"addBtn": `WorkflowsTable_addBtn__6KEs7`
};
export default ___CSS_LOADER_EXPORT___;
